// frontend/src/services/doctorService.js
import apiService from './api';

const doctorService = {
  
  // Get doctor profile
  getProfile: async () => {
    try {
      const response = await apiService.get('/doctors/profile');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update doctor profile
  updateProfile: async (profileData) => {
    try {
      const response = await apiService.put('/doctors/profile', profileData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get doctor statistics
  getStats: async () => {
    try {
      const response = await apiService.get('/doctors/stats');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get subscription info with usage details
  getSubscription: async () => {
    try {
      const response = await apiService.get('/doctors/subscription');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Check consultation limit (using subscription endpoint)
  checkConsultationLimit: async () => {
    try {
      const response = await apiService.get('/doctors/subscription');
      // Return just the usage data for backward compatibility
      if (response.success && response.data) {
        return {
          success: true,
          ...response.data.usage,
          pendingPayment: response.data.pendingPayment
        };
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Subscribe to a plan
  subscribe: async (subscriptionData) => {
    try {
      const response = await apiService.post('/doctors/subscribe', subscriptionData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get subscription history
  getSubscriptionHistory: async () => {
    try {
      const response = await apiService.get('/doctors/subscription-history');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get consultations
  getConsultations: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.status) params.append('status', filters.status);
      if (filters.type) params.append('type', filters.type);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.limit) params.append('limit', filters.limit);

      const response = await apiService.get(`/doctors/consultations?${params.toString()}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Accept consultation
  acceptConsultation: async (consultationId, scheduledAt) => {
    try {
      const response = await apiService.put(
        `/doctors/consultations/${consultationId}/accept`,
        { scheduledAt }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Reject consultation
  rejectConsultation: async (consultationId, reason) => {
    try {
      const response = await apiService.put(
        `/doctors/consultations/${consultationId}/reject`,
        { reason }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Complete consultation
  completeConsultation: async (consultationId, completionData) => {
    try {
      const response = await apiService.put(
        `/doctors/consultations/${consultationId}/complete`,
        completionData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update availability
  updateAvailability: async (availability) => {
    try {
      const response = await apiService.put('/doctors/availability', { availability });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get earnings report
  getEarnings: async (startDate, endDate) => {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await apiService.get(`/doctors/earnings?${params.toString()}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get all doctors (public)
  getAll: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.specialization) params.append('specialization', filters.specialization);
      if (filters.hospital) params.append('hospital', filters.hospital);

      const response = await apiService.get(`/doctors?${params.toString()}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get doctor by ID (public)
  getById: async (id) => {
    try {
      const response = await apiService.get(`/doctors/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default doctorService;